import * as React from 'react';
import { Field } from '@teamsnap/teamsnap-ui';
import { SeasonGuideContext } from './season-guide';
import { chunk } from 'lodash';
import './genders-by-age.scss';
import { DIVISION_GENDERS } from './division-rules';

const GendersByAge = () => {
  const { season, setSeason } = React.useContext(SeasonGuideContext);
  const { genders, ageGroups } = season;

  const updateGenders = (currentGenders: string[], newGender: string) =>
    currentGenders.includes(newGender) ? currentGenders.filter((x) => x !== newGender) : [...currentGenders, newGender];

  return (
    <>
      <p className="u-spaceBottomLg">
        Select divisions based on the general rules for your divisions. You can allow gender exception when rostering.
      </p>

      { chunk(ageGroups, 3).map((chunks, index) => (
        <div className="genders-by-age-row" key={index}>
          { chunks.map((ageGroup) => (
            <div className="genders-by-age-group">
              <p>{ ageGroup.id }</p>
              { genders.map((gender) => {
                const id = ageGroup.id + gender;
                return (
                  <Field
                    key={id}
                    data-testid={`gender-option-${id}`}
                    type="checkbox"
                    name={id}
                    formFieldProps={{
                      text: DIVISION_GENDERS.find((x) => x.id === gender).label,
                      checked: season.ageGroups.find((x) => x.id === ageGroup.id).genders.some((x) => x === gender),
                      onClick: () => {
                        setSeason({
                          ageGroups: season.ageGroups.map((x) =>
                            x.id !== ageGroup.id ? x : { id: x.id, genders: updateGenders(x.genders, gender) }
                          ),
                        });
                      },
                    }}
                  />
                );
              }) }
            </div>
          )) }
        </div>
      )) }
    </>
  );
};

export default GendersByAge;
